'use strict'
var $ = require('jquery');
var TriggerOnView = require('./TriggerOnView.js');

function init(config) {
	var config = $.extend({}, {
		item: 'counter',
		itemParent: 'counterRow',
		variableSpeed: false,
		defaultDuration: 3000,
		minimumDuration: 1200,
		maximumDuration: 4600,
		activeClassModifier: 'active',
		callbacks: {}
	}, config);
	var $numberItem = $('.' + config.item);
	if ($numberItem.length === 0) {
		return;
	}

	if (config.itemActiveClass === undefined) {
		config.itemActiveClass = config.item + '--' + config.activeClassModifier;
	}
	var counters = {
		items: [],
		averageCounterValue: 0,
		maxCounterValue: 0
	};
	var counter = {
		element: null,
		start: 0,
		end: null,
		duration: config.defaultDuration
	}
	var timeRange = config.maximumDuration - config.minimumDuration;

	function initializeCounters() {
		$numberItem.each(function(index, element) {
			counters.items.push(Object.create(counter));
			counters.items[index].element = element;
			counters.items[index].end = parseInt(element.getAttribute('data-end').replace(/,/g, ''));
		});
		if (config.variableSpeed) {
			setVariableDuration();
		}
	}

	function setVariableDuration() {
		// Get max counter value
		counters.maxCounterValue = counters.items.map(function(element, index) {
				return parseInt(element.end, 10);
			})
			.reduce(function(a, b) {
				return b > a ? b : a;
			});
		// Assign new duration based on
		counters.items.forEach(function(element, index) {
			element.duration = (element.end / counters.maxCounterValue) * timeRange + config.minimumDuration;
		});
	}
	/**
	 * Starts individual counter animation
	 * @param  {object} element  The counter as a jQuery object
	 * @param  {number} start    The starting value
	 * @param  {number} end      The ending value
	 * @param  {number} duration The duration of the animation
	 */
	function countStart(element, start, end, duration) {
		$(element).addClass(config.itemActiveClass);
		var updateText = function(value) {
			window.requestAnimationFrame(function() {
				// $(element).text(numberWithCommas(Math.ceil(value)));
				$(element).attr('data-animate', numberWithCommas(Math.ceil(value)));
			});
		};
		$({
			someValue: start
		}).animate({
			someValue: end
		}, {
			duration: duration,
			easing: 'linear',
			step: function() {
				updateText(this.someValue);
			},
			complete: function() {
				updateText(this.someValue);
			}
		});
	}
	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	function activateCounters() {
		counters.items.forEach(function(counter, index) {
			countStart(counter.element, counter.start, counter.end, counter.duration);
		});
	}
	initializeCounters();
	TriggerOnView.triggerThis(config.itemParent, activateCounters, .5);
};
var CountUp = {
	init: init
};
module.exports = CountUp;